import { Stack, Tabs, Text } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Content } from '@/core/components';

import { Id } from '@/feature/utils';

import { JournalImpactFactorMetricTable } from './JournalImpactFactorMetricTable';
import { JournalImpactFactorRankTable } from './JournalImpactFactorRankTable';

interface JournalImpactFactorViewProps {
  journalId: Id;
  journalName: string;
}

export function JournalImpactFactorView(props: JournalImpactFactorViewProps) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string | null>('metrics');

  return (
    <Stack>
      <Content type="full">
        {' '}
        <Text fw="500">
          {props.journalName} - {t('journals.reputation.impactFactor.view')}
        </Text>
      </Content>

      <Content type="full">
        <Tabs
          value={activeTab}
          onChange={setActiveTab}
        >
          <Tabs.List>
            <Tabs.Tab value="metrics">{t('journals.reputation.impactFactor.tabs.metrics')}</Tabs.Tab>

            <Tabs.Tab value="ranks">{t('journals.reputation.impactFactor.tabs.ranks')}</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="metrics">
            {activeTab === 'metrics' && <JournalImpactFactorMetricTable journalId={props.journalId} />}
          </Tabs.Panel>
          <Tabs.Panel value="ranks">
            {activeTab === 'ranks' && <JournalImpactFactorRankTable journalId={props.journalId} />}
          </Tabs.Panel>
        </Tabs>
      </Content>
    </Stack>
  );
}
